import { Group } from '@visx/group';
import {
    barGraphCharacterWidth,
    barGraphLabelAlignTopMinHeight,
    barGraphLabelHorizontalOffset,
    barGraphLabelVerticalOffset
} from '../Config';

/**
 * Total labels displayed on top of the bars in a bar chart.
 */
export const BarTotals = ({
    totals,
    isHorizontal
}: {
    totals: { label: string; x: number; y: number | null; width: number; id: string }[];
    isHorizontal: boolean;
}) => (
    <Group className='bar-totals'>
        {totals.map(({ label, x, y, width: barWidth, id }) => {
            const labelMargin = isHorizontal ? barGraphLabelHorizontalOffset : barGraphLabelVerticalOffset;

            const labelX = isHorizontal ? x + labelMargin : x + barWidth / 2;
            const labelY = isHorizontal ? (y ?? 0) + barWidth / 2 : (y ?? 0) - labelMargin;

            // if the label is too long to fit in the bar, hide it
            const isHidden =
                label.length <= 0 ||
                (!isHorizontal && barWidth < label.length * barGraphCharacterWidth) ||
                (isHorizontal && barWidth < barGraphLabelAlignTopMinHeight);

            if (isHidden) {
                return null;
            }

            return (
                <text
                    key={id}
                    x={labelX}
                    y={labelY}
                    textAnchor={isHorizontal ? 'start' : 'middle'}
                    alignmentBaseline='central'
                    pointerEvents='none'
                    fill='currentColor'
                    fontSize={11}
                >
                    {label}
                </text>
            );
        })}
    </Group>
);
